/**
 * Recently used issuing states, stored on this device only. The backend keeps
 * no per-user state history, so "recent" honestly means "states this browser
 * has saved a plate with" — a fresh device shows nothing invented.
 */

const KEY = 'parkingpay.web.recentStates';
const MAX_RECENT = 5;

export function loadRecentStates(): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((s): s is string => typeof s === 'string') : [];
  } catch {
    return [];
  }
}

export function recordRecentState(state: string): void {
  const next = [state, ...loadRecentStates().filter((s) => s !== state)].slice(0, MAX_RECENT);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Blocked storage only costs the ordering convenience, never the save.
  }
}

/**
 * Groups for the state picker: IL and neighbours (the server's priority list)
 * first, then this device's recent picks, then everything else. Each state
 * appears exactly once, and unknown recents (not in `all`) are dropped.
 */
export function orderStateGroups(
  priority: string[],
  all: string[],
  recent: string[],
): { priority: string[]; recent: string[]; rest: string[] } {
  const recentExtra = recent.filter((s) => !priority.includes(s) && all.includes(s));
  return {
    priority,
    recent: recentExtra,
    rest: all.filter((s) => !priority.includes(s) && !recentExtra.includes(s)),
  };
}
